import * as types from './types';
import { disclosuresType } from '../../../utils/config';

const initialState = {
  options: { name: disclosuresType.CAN, url: '' },
  announcement: {},
  skipDisclosures: false,
  skipAnnouncements: false
};

const disclosuresReducer = (state = initialState, action) => {
  const payload = action.payload;
  switch (action.type) {
    case types.GET_JSON: {
      return {
        ...state,
        options: { ...payload.data },
      };
    }
    case types.GET_ANNOUNCEMENT_JSON: {
      return {
        ...state,
        announcement: { ...payload.data },
      };
    }
    case types.CLEAR_JSON:
      return initialState;
    default:
      return state;
  }
};
export default disclosuresReducer;
